import React, {useRef, useEffect, useMemo} from 'react';
import {Platform, View} from 'react-native';
import Lottie from 'lottie-react-native';
import {RFValue} from 'react-native-responsive-fontsize';

interface Props {
  width?: number;
  height?: number;
  speed?: number;
  autoPlay?: boolean;
  loop?: boolean;
}

export function Piggy({
  width,
  height,
  speed = 1,
  autoPlay = true,
  loop = true,
}: Props) {
  const lottieRef = useRef<Lottie>(null);
  const source = useMemo(
    () => require('../../../assets/images/json/piggy2.json'),
    [],
  );
  useEffect(() => {
    if (autoPlay && lottieRef.current) {
      lottieRef.current.play();
    }
  }, [autoPlay]);

  return (
    <View style={{width: width ?? RFValue(14), height: height ?? RFValue(14)}}>
      {source && (
        <Lottie
          ref={Platform.OS === 'web' ? undefined : lottieRef}
          // se você estiver trocando o JSON e não refletir no Android, mude esse sufixo:
          key="piggy-v1"
          source={source}
          style={{width: '100%', height: '100%'}}
          autoPlay={autoPlay}
          loop={loop}
          speed={speed}
          cacheComposition={false}
          renderMode={Platform.OS === 'android' ? 'SOFTWARE' : 'AUTOMATIC'}
          enableMergePathsAndroidForKitKatAndAbove
          hardwareAccelerationAndroid
        />
      )}
    </View>
  );
}
